import { Platform, type ViewStyle } from 'react-native'
import type { Theme } from '../src/theme/getTheme'

const HERO_MIN_HEIGHT = 180
const GROUP_IMAGE_SIZE = 64

export const getGroupLeaderboardHeroStyleSheet = (theme: Theme) => ({
  container: { flex: 1 },
  hero: {
    minHeight: HERO_MIN_HEIGHT,
    paddingTop: Platform.OS === 'web' ? 80 : 16,
    paddingBottom: 24,
    paddingHorizontal: 16,
    justifyContent: 'flex-end' as const,
  },
  heroActionsRow: {
    position: 'absolute' as const,
    top: Platform.OS === 'web' ? 80 : 16,
    left: 0,
    right: 0,
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
    justifyContent: 'space-between' as const,
    paddingHorizontal: 8,
    zIndex: 1,
  },
  backButtonOnHero: {
    padding: 8,
    marginLeft: -8,
  },
  backButtonOnHeroPressed: {
    opacity: 0.7,
  },
  backButtonOnHeroHover: {
    opacity: 0.85,
  },
  headerActions: {
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
    gap: 8,
    minWidth: 80,
    justifyContent: 'flex-end' as const,
  },
  heroContent: {
    alignItems: 'center' as const,
    paddingHorizontal: 16,
  },
  groupImageContainer: {
    width: GROUP_IMAGE_SIZE,
    height: GROUP_IMAGE_SIZE,
    borderRadius: GROUP_IMAGE_SIZE / 2,
    backgroundColor: theme.white,
    overflow: 'hidden' as const,
    marginBottom: 12,
    borderWidth: 3,
    borderColor: theme.white,
    shadowColor: theme.shadow,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 8,
    elevation: 4,
  },
  groupImage: {
    width: '100%' as const,
    height: '100%' as const,
  },
  groupTitleRow: {
    position: 'relative' as const,
    minHeight: 60,
    paddingHorizontal: 16,
    width: '100%' as const,
    justifyContent: 'center' as const,
    alignItems: 'center' as const,
  },
  groupTitleNameWrap: {
    flex: 1,
    width: '100%' as const,
    justifyContent: 'center' as const,
    alignItems: 'center' as const,
    minWidth: 0,
  },
  groupTitleText: {
    fontSize: 24,
    fontWeight: '800' as const,
    lineHeight: 30,
    color: theme.white,
    letterSpacing: 0,
    textAlign: 'center' as const,
    textShadowColor: 'rgba(0,0,0,0.2)',
    textShadowOffset: { width: 0, height: 1 },
    textShadowRadius: 3,
  },
  groupTitleInput: {
    width: '100%' as const,
    paddingVertical: 0,
    paddingHorizontal: 0,
    margin: 0,
    backgroundColor: 'transparent',
    borderWidth: 0,
    minWidth: 80,
    ...(Platform.OS === 'web' && {
      outlineWidth: 0,
      outlineColor: 'transparent',
    } as ViewStyle),
  },
  groupTitleIconWrap: {
    position: 'absolute' as const,
    left: '50%' as const,
    padding: 6,
    borderRadius: 8,
  },
  groupTitleIconWrapPressed: { opacity: 0.7 },
  groupTitleIconWrapHover: { opacity: 0.85 },
  listWrapper: {
    flex: 1,
  },
  listHeaderFixed: {
    paddingHorizontal: 12,
    paddingBottom: 0,
    backgroundColor: theme.background.primary,
    borderBottomWidth: 1,
    borderBottomColor: theme.gray[200],
  },
  tableHeaderContainer: {
    paddingBottom: 0,
    backgroundColor: theme.background.primary,
    borderBottomWidth: 1,
    borderBottomColor: theme.gray[200],
  },
  leaveGroupFooter: {
    paddingVertical: 24,
    paddingHorizontal: 16,
    alignItems: 'center' as const,
    borderTopWidth: 1,
    borderTopColor: theme.gray[200],
  },
  leaveGroupButton: {
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderRadius: 12,
    backgroundColor: theme.error,
    minWidth: 160,
    alignItems: 'center' as const,
  },
  leaveGroupButtonText: {
    fontSize: 15,
    color: theme.white,
    fontWeight: '600' as const,
  },
  empty: {
    flex: 1,
    justifyContent: 'center' as const,
    alignItems: 'center' as const,
    padding: 32,
  },
  emptyText: { fontSize: 16, color: theme.gray[900], textAlign: 'center' as const },
  retryButton: {
    marginTop: 16,
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderRadius: 12,
    backgroundColor: theme.primary,
    minWidth: 140,
    alignItems: 'center' as const,
  },
  retryButtonPressed: {
    opacity: 0.8,
  },
  retryButtonHover: {
    opacity: 0.9,
  },
  retryButtonText: {
    fontSize: 15,
    fontWeight: '600' as const,
    color: theme.white,
  },
})
